<template>
  <div class="wrapper d-flex justify-center align-center">
    <v-menu :persistent="!true" :location="isCompact ? 'right' : undefined">
      <template v-slot:activator="{ props }">
        <v-btn
          v-if="!isCompact"
          append-icon="mdi-chevron-down"
          class="content-size"
          variant="text"
          v-bind="props"
          width="100%"
          data-testid="account-nav-activator">
          <span class="text-truncate">
            {{ userDisplayName }}
          </span>
        </v-btn>
        <v-tooltip v-else location="right">
          <template v-slot:activator="{ props: tooltipProps }">
            <div v-bind="tooltipProps">
              <v-btn
                v-bind="props"
                data-testid="account-nav-activator"
                icon
                size="x-small"
                class="inverted-color">
                <v-icon size="large">mdi-account</v-icon>
              </v-btn>
            </div>
          </template>
          <span>{{ $t('global.phrases.myAccount') }}</span>
        </v-tooltip>
      </template>
      <v-list>
        <v-list-item
          class="account-option"
          v-for="item in translatedAccountOptions"
          :key="`${item.action}-${item.title}`">
          <v-btn
            :prepend-icon="item.icon"
            class="text-left justify-start"
            @click="handleClick(item.action)">
            <span class="flex-grow-1 justify-start">
              {{ item.title }}
            </span>
          </v-btn>
        </v-list-item>
      </v-list>
    </v-menu>

    <my-account-dialog
      :show-dialog="dialogs.showAccountDialog"
      :external-activator="true"
      @saved="data => $emit('saved', data)"
      @close="dialogs.showAccountDialog = false"></my-account-dialog>
  </div>
</template>

<script>
import renderMixin from '@satellite/components/mixins/renderMixin';
import { logoutAndRedirect } from '@satellite/helpers/logoutAndRedirect';
/**
 * @displayName Account Navigation
 */
export default {
  mixins: [renderMixin],
  props: {
    isCompact: {
      type: Boolean,
      required: false,
      default: false
    },
    accountOptions: {
      type: Array,
      required: false
    }
  },
  computed: {
    translatedAccountOptions() {
      return (
        this.accountOptions ?? [
          {
            title: this.$t('global.basicTerms.account'),
            icon: 'mdi-account',
            action: 'openAccountDialog'
          },
          {
            title: this.$t('global.basicTerms.logout'),
            icon: 'mdi-logout',
            action: 'logout'
          }
        ]
      );
    },
    userDisplayName() {
      return this.$me ? `${this.$me.firstName} ${this.$me.lastName}` : 'Guest User';
    }
  },
  data() {
    return {
      dialogs: {
        showAccountDialog: false
      }
    };
  },
  methods: {
    handleClick(action) {
      this[action]();
    },
    /**
     * Open the account dialog
     * @public
     */
    openAccountDialog() {
      this.dialogs.showAccountDialog = true;
    },
    /**
     * Logout of account
     * @public
     */
    logout() {
      logoutAndRedirect(() => this.$store.dispatch('Auth/logout'));
    }
  }
};
</script>

<style lang="scss">
.content-size {
  span {
    max-width: 100%;
  }
}

.wrapper {
  width: 100%;
}
</style>
